var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgerButtonClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.8735 8.5896C66.8065 6.6566 66.8065 3.5226 64.8735 1.5896V1.5896C62.9405 -0.343397 59.8065 -0.343397 57.8735 1.5896L33.3735 26.0896L8.87353 1.5896C6.94054 -0.343401 3.80653 -0.343397 1.87354 1.5896V1.5896C-0.0594616 3.5226 -0.0594612 6.6566 1.87354 8.5896L26.3735 33.0896L1.87353 57.5896C-0.0594647 59.5226 -0.0594613 62.6566 1.87354 64.5896V64.5896C3.80653 66.5226 6.94054 66.5226 8.87353 64.5896L33.3735 40.0896L57.8735 64.5896C59.8065 66.5226 62.9405 66.5226 64.8735 64.5896V64.5896C66.8065 62.6566 66.8065 59.5226 64.8735 57.5896L40.3735 33.0896L64.8735 8.5896Z",
    fill: "#DED2CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerButtonClose);
export default __webpack_public_path__ + "static/media/burger_button-close.e5ce4d1fe5db7c531192e7d3d93cb3d3.svg";
export { ForwardRef as ReactComponent };